var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __spreadArray = (this && this.__spreadArray) || function (to, from) {
    for (var i = 0, il = from.length, j = to.length; i < il; i++, j++)
        to[j] = from[i];
    return to;
};
import ActionTypes from '../actionTypes';
import { dateIndexToNewspapers, toEntityIdsList, toEntityMapById } from '../../shared/functions';
var initialState = {
    isFetching: false,
    didInvalidate: false,
    entitiesByDate: {},
};
/**
 * Derives the next "newspapers" state from the previous one and the current action.
 */
var newspapersReducer = function (state, action) {
    var _a;
    var _b;
    if (state === void 0) { state = initialState; }
    switch (action.type) {
        case ActionTypes.FETCH_NEWSPAPERS_GET_REQUEST:
        case ActionTypes.FETCH_NEWSPAPER_GET_REQUEST:
            return (__assign(__assign({}, state), { isFetching: true, didInvalidate: false, error: undefined }));
        case ActionTypes.FETCH_NEWSPAPERS_GET_RESPONSE:
            return (__assign(__assign({}, state), { isFetching: false, ids: toEntityIdsList(dateIndexToNewspapers(action.payload)), entities: toEntityMapById(dateIndexToNewspapers(action.payload)), entitiesByDate: Object.entries(action.payload).reduce(function (prev, _a) {
                    var _b;
                    var k = _a[0], v = _a[1];
                    return (__assign(__assign({}, prev), (_b = {}, _b[k] = toEntityIdsList(v), _b)));
                }, {}) }));
        case ActionTypes.FETCH_NEWSPAPER_GET_RESPONSE:
            return (__assign(__assign({}, state), { isFetching: false, ids: __spreadArray(__spreadArray([], (_b = state.ids) !== null && _b !== void 0 ? _b : []), [action.payload.id]), entities: __assign(__assign({}, state.entities), (_a = {}, _a[action.payload.id] = action.payload, _a)) }));
        case ActionTypes.FETCH_NEWSPAPERS_GET_INVALIDATE:
        case ActionTypes.FETCH_NEWSPAPER_GET_INVALIDATE:
            return (__assign(__assign({}, state), { isFetching: false, didInvalidate: true, error: action.error, ids: [], entities: {}, entitiesByDate: {} }));
        default:
            return state;
    }
};
export default newspapersReducer;
